import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { AppearanceToggle } from "@/components/settings/appearance-toggle";
import { ProfileForm } from "@/components/settings/profile-form";
import { SettingsRow, SettingsSection } from "@/components/settings/settings-row";
import { profileQuery } from "@/lib/loaders";
import { CookiePreferencesButton } from "@/ui/components/cookie-consent/cookie-preferences-trigger";
import { Switch } from "@/ui/components/ui/switch";

export const Route = createFileRoute("/_workspace/settings/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(profileQuery),
  component: SettingsGeneralPage,
});

function SettingsGeneralPage() {
  const { data: profile } = useQuery(profileQuery);

  return (
    <div className="flex flex-col gap-10">
      <ProfileForm initial={profile ?? null} />
      <SettingsSection title="Preferences" description="Personalize how HR Docket looks and feels.">
        <SettingsRow
          label="Appearance"
          description="HR Docket is light by default — switch to dark if you prefer."
        >
          <AppearanceToggle />
        </SettingsRow>
        <SettingsRow
          label="Cookie preferences"
          description="Choose which optional cookies HR Docket may use. You can change this at any time."
        >
          <CookiePreferencesButton />
        </SettingsRow>
      </SettingsSection>
      <SettingsSection
        title="Notifications"
        description="Decide how HR Docket keeps you in the loop."
      >
        <SettingsRow
          label="Email digest"
          description="A weekly summary of HR activity across your workspace."
        >
          <Switch defaultChecked aria-label="Email digest" />
        </SettingsRow>
        <SettingsRow
          label="Document activity"
          description="Get notified when documents are signed or edited."
        >
          <Switch defaultChecked aria-label="Document activity" />
        </SettingsRow>
        <SettingsRow
          label="Onboarding & offboarding"
          description="Alerts for new hires, status changes, and exits."
        >
          <Switch defaultChecked aria-label="Onboarding alerts" />
        </SettingsRow>
        <SettingsRow
          label="Product updates"
          description="Occasional emails about new HR Docket features."
        >
          <Switch aria-label="Product updates" />
        </SettingsRow>
      </SettingsSection>
    </div>
  );
}
